import { Controller } from "@hotwired/stimulus"

// Shows a preview row when a file is selected in an upload field.
//
// Usage:
//   <div data-controller="file-preview">
//     <input type="file" data-file-preview-target="input"
//            data-action="change->file-preview#preview">
//     <div data-file-preview-target="preview" class="hidden">
//       <span data-file-preview-target="ext"></span>
//       <span data-file-preview-target="name"></span>
//       <span data-file-preview-target="size"></span>
//       <button data-action="file-preview#remove">X</button>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["input", "preview", "name", "size", "ext"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) {
      this.hide()
      return
    }

    const ext = file.name.split(".").pop().toUpperCase()
    this.extTarget.textContent = ext
    this.nameTarget.textContent = this.truncate(file.name, 30)
    this.sizeTarget.textContent = this.formatSize(file.size)
    this.previewTarget.classList.remove("hidden")
  }

  remove() {
    this.inputTarget.value = ""
    this.hide()
  }

  hide() {
    this.previewTarget.classList.add("hidden")
  }

  truncate(str, max) {
    if (str.length <= max) return str
    const ext = str.split(".").pop()
    return str.substring(0, max - ext.length - 4) + "..." + ext
  }

  formatSize(bytes) {
    if (bytes < 1024) return bytes + " B"
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB"
    return (bytes / 1048576).toFixed(2) + " MB"
  }
}
